import { Flex, Typography } from 'antd'
import React, { ReactNode } from 'react'

export type PageHeaderProps = {
    title: ReactNode
    suffix?: ReactNode
    prefix?: ReactNode
    onTitleChanged?: (title: string) => void
    children?: ReactNode
    className?: string
    // Let the actions wrap below the title when there is not enough space.
    wrap?: boolean
}

export function PageHeader({ title, onTitleChanged, children, prefix, suffix, className, wrap }: PageHeaderProps) {
    return (
        <div className={className}>
            <Flex
                justify="space-between"
                wrap={wrap ? 'wrap' : undefined}
                gap={wrap ? 'middle' : undefined}
            >
                <Flex
                    gap="middle"
                    align="start"
                    className="flex-col xl:flex-row"
                >
                    {prefix}
                    <Typography.Title
                        level={2}
                        className="mb-0 font-normal text-[24px]"
                        contentEditable={!!onTitleChanged}
                        suppressContentEditableWarning
                        onBlur={(e) => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onTitleChanged!((e.target as any).innerText)
                        }}
                    >
                        {title}
                    </Typography.Title>
                    <Flex
                        gap="small"
                        align="center"
                        className="xl:self-stretch"
                    >
                        {suffix}
                    </Flex>
                </Flex>

                {children}
            </Flex>
        </div>
    )
}
